import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-35cd6c58"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "msi-form" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_4 = { class: "msi-content" }
const _hoisted_5 = { class: "header" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("工量具批量归还")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("导出")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("原件归还")
const _hoisted_9 = {
  class: "msi-content",
  style: {"margin-top":"0","padding":"0"}
}
const _hoisted_10 = { class: "header" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("删除选中行")
const _hoisted_12 = { class: "dialog-footer" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("确认")

import {
  WareToolReturnPage,
  returnWareToolReturn
} from "@/service/main/gauge/return";
import Pagination from "@/components/Pagination/index.vue";
import { exportExcel } from "@/utils/exportExcel";
import { ElMessage, ElMessageBox } from "element-plus";
import { ref } from "vue";
import { formatUtcToData } from "@/utils/formate";
import { useStore } from "@/store";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();

// --------------------出库单列表-----------------------------------
//查询
const formModel = ref({
  Name: "",
  Code: "",
  BorrowUserName: "",
  PageNo: 1,
  PageSize: 10
});

//出库单列表数据
let tableData = ref([]);

//列表的数据条数
const totalItems = ref<number>(0);

//获取出库单列表
const getTabelData = () => {
  WareToolReturnPage(formModel.value)
    .then((res) => {
      if (res.code == 200) {
        const { data } = res;
        const result = data;
        result.rows.map(
          (item: { hasChildren: boolean }) => (item.hasChildren = true)
        );
        tableData.value = result.rows;
        totalItems.value = result.totalRows;
      } else {
        ElMessage.error(`${res.code}:${JSON.stringify(res.message)}`);
      }
    })
    .catch((err) => {
      console.log(err);
      ElMessage.error(JSON.stringify(err));
    });
};
getTabelData();

//重置搜索
const resetForm = () => {
  formModel.value = {
    Name: "",
    Code: "",
    BorrowUserName: "",
    PageNo: 1,
    PageSize: 10
  };
  getTabelData();
};
// -----------------删除、导出操作--------------------------
//选中的行
const checkRows = ref<{ orderNo: string }[]>([]);
// 选择
const handleSelectionChange = (val: any) => {
  checkRows.value = val;
};
//导出
const handExport = () => {
  let entozh = {
    id: "序号",
    code: "工量具编号",
    name: "工量具名称",
    orderspecificationModeltatus: "工量具规格",
    borrowUserName: "借用人",
    borrowTime: "借用日期",
    borrowQuantity: "借出数量",
    returnQuantity: "已归还数量",
    未归还数量: "未归还数量"
  };
  exportExcel(checkRows.value, entozh, "xlsx", "工量具归还列表");
};
//批量归还
const handle = () => {
  const handleArr: string[] = [];
  checkRows.value.forEach((item: any) => {
    item.createdTime = formatUtcToData(
      new Date().toString(),
      "YYYY-MM-DD hh:mm:ss"
    );
    handleArr.push(item);
  });
  openDialog(2, handleArr);
};

//删除选中的物料详情
const delCheckedDetails = () => {
  ElMessageBox.confirm("是否确认删除？", "提示", {
    confirmButtonText: "确认",
    cancelButtonText: "取消",
    type: "warning"
  })
    .then(() => {
      checkedDetails.value.forEach((item) => {
        const index = warehousOrderDetails.value.findIndex(
          (detail) => detail.code == item.code
        );
        warehousOrderDetails.value.splice(index, 1);
      });
    })
    .catch(() => ElMessage.info("已取消删除"));
};

// ----------------归还-------------------------------
//窗口类型
const dialogType = ref("add");

const dialogVisible = ref(false);

//打开归还窗口
const openDialog = (type: number, scope: any = {}) => {
  if (type == 1) {
    dialogType.value = "add";
    scope.createdTime = formatUtcToData(
      new Date().toString(),
      "YYYY-MM-DD hh:mm:ss"
    );
    warehousOrderDetails.value = [];
    warehousOrderDetails.value.push(scope);
  } else {
    warehousOrderDetails.value = [];
    dialogType.value = "add";
    warehousOrderDetails.value = scope;
  }
  dialogVisible.value = true;
};

//物料详情的table ref
const detailRef = ref();

//关闭窗口
const closeDialog = () => {
  warehousOrderDetails.value = [];
  checkedDetails.value = [];
  detailRef.value.clearSelection();
};

//归还窗口物料列表
const warehousOrderDetails = ref<any[]>([]);

//物料详情列表选中的物料
const checkedDetails = ref<any[]>([]);

//物料详情列表中勾选事件
const detailsCheckChange = (val: any) => {
  checkedDetails.value = val;
};
// const printTable = () => {
// };
const params = ref<any>([]);

//归还
const confirm = () => {
  warehousOrderDetails.value.forEach((item) => {
    params.value.push({
      createdUserId: store.state.login.userInfo.id,
      createdUserName: store.state.login.userInfo.name,
      createdTime: formatUtcToData(
        new Date().toString(), 
        "YYYY-MM-DD hh:mm:ss"
      ),
      updatedTime: formatUtcToData(
        new Date().toString(),
        "YYYY-MM-DD hh:mm:ss"
      ),
      quantity: item.borrowQuantityReturnQuantity,
      code: item.code,
      id: item.id
    });
  });
  returnWareToolReturn(params.value)
    .then((res) => {
      if (res.code == 200) {
        ElMessage.success("归还成功");
        dialogVisible.value = false; 
        getTabelData();
      } else {
        ElMessage.error(`归还失败${res?.code}:${JSON.stringify(res.message)}`);
      }
    })
    .catch((err) => {
      console.log(err);
      ElMessage.error(JSON.stringify(err));
    });
};

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_form, {
        model: formModel.value,
        "label-width": "120px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 6 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "工量具名称:" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: formModel.value.Name,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formModel.value.Name) = $event)),
                        clearable: "",
                        placeholder: "请输入工量具名称"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 6 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "工量具编号:" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: formModel.value.Code,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formModel.value.Code) = $event)),
                        clearable: "",
                        placeholder: "请输入工量具编号"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 6 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "借用人:" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: formModel.value.BorrowUserName,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formModel.value.BorrowUserName) = $event)),
                        clearable: "",
                        placeholder: "请输入借用人"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 4 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { "label-width": "20px" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        icon: "el-icon-search",
                        onClick: getTabelData
                      }, {
                        default: _withCtx(() => [
                          _hoisted_2
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_button, {
                        icon: "el-icon-refresh-right",
                        onClick: resetForm
                      }, {
                        default: _withCtx(() => [
                          _hoisted_3
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", null, [
          _createVNode(_component_el_button, {
            type: "info",
            icon: "el-icon-download",
            plain: "",
            disabled: checkRows.value.length == 0,
            onClick: handle
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_el_button, {
            type: "info",
            plain: "",
            icon: "el-icon-upload2",
            disabled: checkRows.value.length == 0,
            onClick: handExport
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ]),
      _createVNode(_component_el_table, {
        data: _unref(tableData),
        border: "",
        style: {"width":"100%"},
        "row-key": "id",
        onSelectionChange: handleSelectionChange
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            width: "60",
            align: "center",
            type: "selection",
            "reserve-selection": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "序号",
            align: "center",
            width: "60",
            type: "index"
          }),
          _createVNode(_component_el_table_column, {
            label: "工量具编号",
            width: "240",
            align: "center",
            prop: "code",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "工量具名称",
            prop: "name",
            align: "center",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "工量具规格",
            prop: "specificationModel",
            align: "center",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "借用人",
            prop: "borrowUserName",
            align: "center",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "借用日期",
            prop: "borrowTime",
            align: "center",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "借出数量",
            prop: "borrowQuantity",
            align: "center",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "已归还数量",
            prop: "returnQuantity",
            align: "center",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "未归还数量",
            prop: "borrowQuantityReturnQuantity",
            align: "center",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "操作",
            width: "220px",
            align: "center"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_button, {
                type: "info",
                plain: "",
                size: "small",
                icon: "el-icon-edit",
                onClick: ($event: any) => (openDialog(1, scope.row))
              }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"]),
      _createVNode(Pagination, {
        total: totalItems.value,
        page: formModel.value.PageNo,
        "onUpdate:page": _cache[3] || (_cache[3] = ($event: any) => ((formModel.value.PageNo) = $event)),
        limit: formModel.value.PageSize,
        "onUpdate:limit": _cache[4] || (_cache[4] = ($event: any) => ((formModel.value.PageSize) = $event)),
        onPagination: getTabelData,
        style: {"margin-top":"20px","text-align":"center"}
      }, null, 8, ["total", "page", "limit"])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((dialogVisible).value = $event)),
      title: "工量具归还",
      width: "60%",
      onClose: closeDialog
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_12, [
          _createVNode(_component_el_button, {
            onClick: _cache[5] || (_cache[5] = ($event: any) => (dialogVisible.value = false))
          }, {
            default: _withCtx(() => [
              _hoisted_13
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            disabled: warehousOrderDetails.value.length == 0,
            onClick: confirm
          }, {
            default: _withCtx(() => [
              _hoisted_14
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", null, [
              _createVNode(_component_el_button, {
                type: "info",
                icon: "el-icon-delete",
                plain: "",
                disabled: checkedDetails.value.length == 0,
                onClick: delCheckedDetails
              }, {
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 1
              }, 8, ["disabled"])
            ])
          ]),
          _createVNode(_component_el_table, {
            data: warehousOrderDetails.value,
            border: "",
            style: {"width":"100%"},
            "row-key": "id",
            ref_key: "detailRef",
            ref: detailRef,
            onSelectionChange: detailsCheckChange
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                align: "center",
                width: "60",
                "reserve-selection": "",
                type: "selection"
              }),
              _createVNode(_component_el_table_column, {
                label: "序号",
                align: "center",
                width: "60",
                type: "index"
              }),
              _createVNode(_component_el_table_column, {
                label: "工量具编号",
                prop: "code",
                align: "center",
                "show-overflow-tooltip": ""
              }),
              _createVNode(_component_el_table_column, {
                label: "工量具名称",
                prop: "name",
                align: "center",
                "show-overflow-tooltip": ""
              }),
              _createVNode(_component_el_table_column, {
                label: "工量具规格",
                prop: "specificationModel",
                align: "center",
                "show-overflow-tooltip": ""
              }),
              _createVNode(_component_el_table_column, {
                label: "归还数量",
                align: "center",
                width: "160"
              }, {
                default: _withCtx((scope) => [
                  _createVNode(_component_el_input_number, {
                    modelValue: scope.row.borrowQuantityReturnQuantity,
                    "onUpdate:modelValue": ($event: any) => ((scope.row.borrowQuantityReturnQuantity) = $event),
                    min: 1,
                    size: "small"
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "归还人",
                prop: "borrowUserName",
                align: "center",
                "show-overflow-tooltip": ""
              }),
              _createVNode(_component_el_table_column, {
                label: "归还日期",
                prop: "createdTime",
                align: "center",
                "show-overflow-tooltip": ""
              })
            ]),
            _: 1
          }, 8, ["data"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})